import React, { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { BiBadgeCheck, BiXCircle } from "react-icons/bi";
import InquiryModal from "../Inquiry/InquiryModal";

const OurServicesModal = ({
  ourServicesModal,
  setOurServicesModal,
  productList,
}) => {

  const [isInquiryMdl, setIsInquiryMdl] = useState(false);
  const [inquiryData, setInquiryData] = useState(null);

  const handleInquiryOfProduct = (data) => {
    setInquiryData(data || null);
    setIsInquiryMdl(!isInquiryMdl);
  }

  return (
    <div>
      <Modal
        backdrop="static"
        keyboard={false}
        show={ourServicesModal}
        onHide={() => {
          setOurServicesModal(!ourServicesModal)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex align-items-center gap-2">
              <img
                src={productList.Icon}
                alt=""
                width={40}
                height={40}
              />
              <div>
                <div>{productList.category_name}</div>
                <div className="text-xs text-primary">
                  Currently uses : {productList.productUsed} out of{" "}{productList.productCount}
                </div>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {productList.data.map((item, index) => (
              <Col md={6} key={index}>
                <div className="fw-normal d-flex py-1" onClick={() => handleInquiryOfProduct(item)}>
                  {item.ITEM_USED === "Y" ?
                    <BiBadgeCheck className="text-lg me-2 text-success" />
                    :
                    <BiXCircle className="text-lg me-2 text-danger" />
                  }
                  <span className="outstanding-amount-text text-sm">{item.ITEM_NM}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>

      {
        isInquiryMdl && (
          <InquiryModal
            isOpen={isInquiryMdl}
            handleProductDtlMdl={handleInquiryOfProduct}
            inquiryData={inquiryData}
          />
        )
      }
    </div >
  );
};

export default OurServicesModal;
